export default "__VITE_ASSET__fe8036ff__"